module.exports = __webpack_public_path__ + "static/media/yellow-arrow-right.3cdb950f.png";